module.exports = __webpack_public_path__ + "media/images/lov_it5-f919c3183be0f19006a6b69988119a88.png";